import React from "react";
import Layout from "../../../../../../components/layouts/Layout";
import AddCareNotes from "../../../AddCareNotes";

function AddPublicInteraction() {
  return (
    <>
      <Layout pageTitleText="Notes">
        <div className="incidents consentCapacityAddNew">
          <div className="mainContent ">
            <div className="mainContentText">
              <h3>Add Public Interaction note</h3>
              <AddCareNotes noteType="PublicInteraction" parentListNoteUrl="/care-plan/general-notes" />
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}


export default AddPublicInteraction